import "./App.css";
import { useEffect, useState } from "react";
import AppRouter from "./Components/Main/Router/AppRouter";
import { AuthProvider } from "./AuthProvider/AuthContext";
import TravelLoader from "./Components/Loader/Loader";
import MakeBeeTripChatbot from "./Components/AI/MakeBeeTripChatbot";
import { AIChatProvider } from "./Components/AI/AIChatContext";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1700);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <TravelLoader />;
  }

  return (
    <AuthProvider>
      <AIChatProvider>
        <AppRouter />
        <MakeBeeTripChatbot />
      </AIChatProvider>
    </AuthProvider>
  );
}

export default App;